// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function Spinner(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : 20;
  var sizePx = size.toString() + "px";
  var strokeColor = Core__Option.getOr(props.stroke, "var(--color-silver)");
  return JsxRuntime.jsx("svg", {
              children: JsxRuntime.jsx("circle", {
                    className: "animate-tan-spinner-dash",
                    cx: "25",
                    cy: "25",
                    fill: "none",
                    r: "20",
                    stroke: strokeColor,
                    strokeLinecap: "butt",
                    strokeWidth: "6"
                  }),
              className: "inline-block animate-tan-spinner-rotate",
              height: sizePx,
              width: sizePx,
              viewBox: "0 0 50 50"
            });
}

var make = Spinner;

exports.make = make;
/* react/jsx-runtime Not a pure module */
